import { HIGH_RES_TIME_RATE, HIGHT_VOLUME_SAMPLING_RATE, SCROLLBAR_SAMPLING_RATE } from './../../../shared/services/scrollbar-chart-settings.service';
import { PadService } from './../../../shared/services/pad.service';
import { KEY_TEMPLATE_ID, RealtimeTreatmentStorageService, PAD_COMPARE_WELL } from './../../../shared/services/realtime-treatment-storage.service';
import { ChannelSettingsStorageService } from './../../../shared/services/channel-settings-storage.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { cloneDeep, flatten, isArray, isEmpty, isEqual, forEach, isNil } from 'lodash';
import * as moment from 'moment';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { flatMap, map, finalize } from 'rxjs/operators';
import { MultiWellChartComponent } from '../../../shared/components/charts';
import { ICompareWellsTimeControl } from '../../../shared/components/compare-wells-time-control/compare-wells-time-control.model';
import { CompareWellsTimeControlService } from '../../../shared/components/compare-wells-time-control/compare-wells-time-control.service';
import { ChannelSelectionComponent } from '../../../shared/components/modals/channel-selection/channel-selection.component';
import { TimeSettingsComponent } from '../../../shared/components/modals/time-settings/time-settings.component';
import { WellsSelectionModalComponent } from '../../../shared/components/modals/wells-selection-modal/wells-selection-modal.component';
import { IResSelectPivotPoint, PivotPointSelectComponent } from '../../../shared/components/pivot-point-select/pivot-point-select.component';
import { CHART_MESSAGES, DEFAULT_INIT_TEMPLATE_NAME, ENUM_COLOR_MODE, PLOT_TEMPLATE_TYPE, TIME_SETTING_TYPE } from '../../../shared/helpers/app.constants';
import { Helper } from '../../../shared/helpers/helper';
import { IChannelMappingResponse, IChannelSettingModel, IMappedChannel, ITimeSetting } from '../../../shared/models';
import { IPlotTemplate, IPlotTemplateResponse } from '../../../shared/models/plot-template.model';
import { ChannelMappingService, ChannelMappingStorageService, ChannelSelectionService, FracproChannelsService, FracproChannelStorageService, LoadingOverlayService, PlotTemplateService, UserAuthService } from '../../../shared/services';
import { CONST_CURSOR_OPTIONS, ENUM_CURSOR_OPTS, MultiWellChartService } from '../../../shared/services/charts';
import { ChartsService, ITreatmentChartRequestOption } from '../../../shared/services/charts.service';
import { CompareWellsService } from '../../../shared/services/compare-wells.service';
import { NavbarScaleChartService } from '../../../shared/services/navbar-scale-chart.service';
import { IScrollbarChartSettings, KEY_SCROLLBAR_SETTINGS, ScrollbarChartSettingsService } from '../../../shared/services/scrollbar-chart-settings.service';
import { TreatmentService } from '../../../shared/services/treatment.service';
import { CompareParameterMultiWellsComponent } from '../compare-parameter-multi-wells/compare-parameter-multi-wells.component';
import { IWellsCompareInputData, WellsCompareDataService } from '../wells-compare-data.service';
import { CmwWellsSelectTreatmentsComponent } from './cmw-wells-select-treatments/cmw-wells-select-treatments.component';
import { CompareMultipleWellDataService } from './compare-multiple-well-data.service';
import { CompareMultipleWellNavigatorDataService } from './compare-multiple-well-navigator-data.service';
import { CompareMultipleWellService } from './compare-multiple-well.service';
import { TreatmentLogTemplateService } from '../../../shared/services/treatment-log-template.service';
import { TreatmentLogParserService } from '../../../shared/services/treatment-log-parser.service';

@Component({
  selector: 'app-compare-multiple-well',
  templateUrl: './compare-multiple-well.component.html',
  styleUrls: ['./compare-multiple-well.component.scss']
})
export class CompareMultipleWellComponent implements OnInit, OnDestroy {
  cursorSelected: any = {id: 'default', text: 'Default', typeCursor: ENUM_CURSOR_OPTS.LargeCross, icon: 'icon-mouse-pointer'};
  cursorOpts = [this.cursorSelected].concat(CONST_CURSOR_OPTIONS);

  TIME_SETTING_TYPE = TIME_SETTING_TYPE;

  @ViewChild(MultiWellChartComponent) highChart: MultiWellChartComponent;
  @ViewChild(CompareParameterMultiWellsComponent) scatterHighChart: CompareParameterMultiWellsComponent;
  @ViewChild(CmwWellsSelectTreatmentsComponent) childComponentListWells: CmwWellsSelectTreatmentsComponent;
  @ViewChild(PivotPointSelectComponent) pivotPointSelectComponent: PivotPointSelectComponent;

  subscriptions: Subscription[] = [];

  // Button dropdown
  optionsExportOpened: boolean = false;
  optionsPivotOpened: boolean = false;
  exportList: string[] = ['Save PNG', 'Save JPEG', 'Print Chart'];
  pivotList: any[] = [
    { id: 'JobTime', text: 'Job time' },
    { id: 'TimeStart', text: 'Start Stage1' },
    { id: 'BreakDownTime', text: 'Breakdown' },
    { id: 'InitialShutinPresTime', text: 'ISIP' },
    { id: 'WellOpenTime', text: 'Well Open' },
    { id: 'WellClose', text: 'Well Close' },
    { id: 'BallSeatTime', text: 'BallSeat' },
  ];

  loading: boolean = false;
  treatmentData: boolean = false;
  loadingChannels = true;

  isCompareSingleWell: boolean = false;
  isDisplayTooltip: boolean = true;

  realtimeChannels = [];
  fracproChannels = [];
  treatmentChannels = [];

  // Treatment
  treatment: any[] = [];

  // Parameter
  parameterList: any[] = [];

  // Well Select
  wellId: number;
  wellList: any[] = [];
  wellNameList: string = '';

  // Well Treatment
  treatmentId: number;

  channelMapping: any[] = [];

  // Charts variables
  chartInputState: any = {
    channelSettings: {},
    filterSettings: {},
    inputData: {},
    navigatorInputData: {},
    pivotPointData: [],
    wellOptions: []
  };
  queryParams: any = {
    wellId: '',
    treatmentId: ''
  };
  channelSettings: IChannelSettingModel;
  filterSettings: ITimeSetting = {
    type: TIME_SETTING_TYPE.EpochTime,
    startIndex: null,
    endIndex: null,
    multiWellScrollbar: true,
    scrollbarSamplingRate: parseInt(SCROLLBAR_SAMPLING_RATE, 10) * 60, // sec
    highVolumeSamplingRate: parseInt(HIGHT_VOLUME_SAMPLING_RATE, 10), // sec
    highResTimeRate: parseInt(HIGH_RES_TIME_RATE, 10), // min
    showWellAliasInTag: true
  };
  chartInputData: any = [];
  paramInputData: IWellsCompareInputData;
  pivotPointData: any = [];
  navigatorInputData: any = [];
  mappedChannelData: any = [];
  defaultColor: string[] = ['#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f'];

  companyId: any = null;
  loadingPlotTemplates: boolean;
  dataPlotTemplates: IPlotTemplateResponse[] = [];
  channelMappingData: IChannelMappingResponse[] = [];
  fracProChannelsLatestVer: any[] = [];
  selectedTemplate: IPlotTemplateResponse;

  wellTimeZoneFirstOffset: number = 0;
  wellTimeZoneFirstName: string;
  curRangeTimeMin: number;

  startDateFilter: number = 0;
  endDateFilter: number = 0;

  compareWellsTimeControl: ICompareWellsTimeControl = this.compareWellsTimeControlService.getInitialState();
  wellListLength$: Observable<any>;
  wellList$: Observable<any>;
  singleWell$: Observable<any>;
  selectedTreatmentsMultiWells$: Observable<any>;
  selectedTreatmentsSingleWell$: Observable<any>;
  isCompareSingle$: Observable<boolean>;
  highVolumeSamplingRate;

  padName: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userAuthService: UserAuthService,
    private dialogService: NbDialogService,
    private chartsService: ChartsService,
    private plotTemplateService: PlotTemplateService,
    private compareWellsService: CompareWellsService,
    private channelSelectionService: ChannelSelectionService,
    private wellsCompareDataService: WellsCompareDataService,
    private loadingOverlayService: LoadingOverlayService,
    private navbarScaleChartService: NavbarScaleChartService,
    private treatmentService: TreatmentService,
    private multiWellChartService: MultiWellChartService,
    private channelMappingService: ChannelMappingService,
    private channelMappingStorageService: ChannelMappingStorageService,
    private compareMultipleWellService: CompareMultipleWellService,
    private compareMultipleWellDataService: CompareMultipleWellDataService,
    private compareMultipleWellNavigatorDataService: CompareMultipleWellNavigatorDataService,
    private scrollbarChartSettingsService: ScrollbarChartSettingsService,
    private compareWellsTimeControlService: CompareWellsTimeControlService,
    private channelSettingsStorageService: ChannelSettingsStorageService,
    private realtimeTreatmentStorageService: RealtimeTreatmentStorageService,
    private padService: PadService,
    private fracproChannelStorageService: FracproChannelStorageService,
    private fracproChannelsService: FracproChannelsService,
    private treatmentLogTemplateService: TreatmentLogTemplateService,
    private treatmentLogParserService: TreatmentLogParserService
  ) {
    this.wellListLength$ = this.compareMultipleWellService.wellListLength$;
    this.wellList$ = this.compareMultipleWellService.wellList$;
    this.singleWell$ = this.compareMultipleWellService.singleWell$;
    this.selectedTreatmentsMultiWells$ = this.compareMultipleWellService.selectedTreatmentsMultiWells$;
    this.selectedTreatmentsSingleWell$ = this.compareMultipleWellService.selectedTreatmentsSingleWell$;
  }

  loadingTreatmentLogTemplates: boolean;
  treatmentLogTemplatesData: any;
  public getScatterTemplates(): void {
    this.loadingTreatmentLogTemplates = true;
    this.subscriptions.push(
      this.treatmentLogTemplateService.getTemplates()
      .pipe(finalize(() => this.loadingTreatmentLogTemplates = false))
      .subscribe(response => { this.treatmentLogParserService.setPlotTemplates(response); })
    );
  }

  ngOnInit() {
    // get query parameters
    this.route.queryParams.pipe(flatMap(param => {
      if (param) {
        if (param.hasOwnProperty('padName')) {
          this.padName = param.padName;
          return this.padService.getPadByName(param.padName);
        } else {
          return of(null);
        }
      } else {
        return of(null);
      }
    })).subscribe((res) => {}, (error) => {
      console.log('Not found any Pad: %s', this.padName);
      this.router.navigate(['pages/pads']);
    });

    this.subscriptions.push(
      this.navbarScaleChartService.isLoading.subscribe(value => {
        setTimeout(() => {
          this.highChart.reflow();
          this.scatterHighChart.reflow();
        });
      })
    );
    const currentUser = this.userAuthService.getUserInfo();
    this.companyId = currentUser && currentUser.companyId ? currentUser.companyId : '';
    // get scroll bar settings
    const scrollbarSettings: IScrollbarChartSettings = this.scrollbarChartSettingsService.getLocalStorage(this.companyId || 0, KEY_SCROLLBAR_SETTINGS);
    if (scrollbarSettings) {
      this.filterSettings.multiWellScrollbar = scrollbarSettings.multiWellScrollbar;
      this.filterSettings.scrollbarSamplingRate = scrollbarSettings.scrollbarSamplingRate ? (parseInt(scrollbarSettings.scrollbarSamplingRate, 10) * 60) : (parseInt(SCROLLBAR_SAMPLING_RATE, 10) * 60); // min to seconds;
      this.filterSettings.highVolumeSamplingRate = scrollbarSettings.highVolumeSamplingRate ? parseInt(scrollbarSettings.highVolumeSamplingRate, 10) : parseInt(HIGHT_VOLUME_SAMPLING_RATE, 10);
      this.filterSettings.highResTimeRate = scrollbarSettings.highResTimeRate ? parseInt(scrollbarSettings.highResTimeRate, 10) : parseInt(HIGH_RES_TIME_RATE, 10);
      this.highVolumeSamplingRate = this.filterSettings.highVolumeSamplingRate;
    }
    this.subscriptions.push(
      this.route.data.subscribe(data => {
        if (data && data.compareData) {
          setTimeout(() => {
            this.setInputData(data.compareData);
          });
        }
      })
    );
    // update well list data when there are any change on alias name and color
    this.subscriptions.push(
      this.multiWellChartService.getWellOptionsData().subscribe(wellListOptions => {
        this.wellList = wellListOptions;
      })
    );
    // get Treatment Log Templates
    this.getScatterTemplates();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
    // reset memory data
    this.compareMultipleWellDataService.resetDataByTreatments();
    this.compareMultipleWellNavigatorDataService.resetDataByTreatments();
    this.wellsCompareDataService.resetData();
    this.compareMultipleWellService.unsetWellList();
  }

  onEnter(listWellAliasData) {
    this.updateChart();
  }

  private loadChannelMappingStorage() {
    const channelMapping = this.channelMappingStorageService.getChannelMapped(this.companyId);
    if (!channelMapping || !channelMapping.length) return;
    this.channelMappingData = channelMapping;
  }

  private loadFracproChannelLatestVerStorage() {
    const fracproChannels = this.fracproChannelStorageService.getFracproChannels();
    if (fracproChannels && fracproChannels.length) this.fracProChannelsLatestVer = fracproChannels;
  }

  async setInputData(param: IWellsCompareInputData) {
    this.paramInputData = param;
    // Well
    if (!isEmpty(param.wellSelect)) {
      this.isCompareSingleWell = param.wellSelect.length === 1;
      this.filterSettings.showWellAliasInTag = !this.isCompareSingleWell;
      // init selected treatments
      param.wellSelect.forEach((well, index) => {
        well.treatment = [];
        well.selectedTreatmentList = [];
      });
      const cloneWellSelect = cloneDeep(param.wellSelect);
      const nonWellColor = cloneWellSelect.filter(well => { return !well.wellColor; });
      // format well treatments name by treatment number
      this.wellList = this.compareMultipleWellService.handleWellTreatmentName(
        // populate alias info
        this.compareMultipleWellService.populateAliasInfo(cloneWellSelect)
      );
      for (const well of this.wellList) {
        if (!well.tzTimeZone) well.tzTimeZone = Helper.lookupTimeZone(well.country, well.timeZone);
        if (nonWellColor.findIndex(item => item.wellId === well.wellId) !== -1 && well.wellColor) {
          this.subscriptions.push(
            this.compareWellsService.updateWellColor(well.wellId, well.wellColor).subscribe()
          );
        }
      }
      // set well list subject
      this.compareMultipleWellService.setWellList(this.wellList);

      const wellActive = this.wellList[0];
      this.wellId = wellActive.wellId;

      // update list well name
      this.wellNameList = this.wellList.map(well => well.wellName).join(', ');

      // update data ranges of wells
      this.updateDateRangeWellsTimeControl(this.wellList);

      this.loadingOverlayService.show();
      this.loadingChannels = true;
      const result = await this.loadChannelsForWells(this.wellList);
      if (result) {
        this.realtimeChannels = this.channelSelectionService.handleChannelsColor(result.realtimeChannels, this.channelMappingData);
        this.fracproChannels = this.channelSelectionService.handleChannelsColor(result.fracproChannels, this.fracProChannelsLatestVer);

        // load data from storage first if there is
        this.loadChannelMappingStorage();
        const loadChannelMapping = this.channelMappingData && this.channelMappingData.length ? of(true) : this.channelMappingService.getAll(this.companyId);

        this.loadFracproChannelLatestVerStorage();
        const fracProChannelsLatestVer$ = this.fracProChannelsLatestVer && this.fracProChannelsLatestVer.length ? of(true) : this.fracproChannelsService.getLatestVersion();


        // get list templates
        const subscriped = forkJoin(
          this.plotTemplateService.getByWell(this.wellId),
          loadChannelMapping,
          fracProChannelsLatestVer$
        ).subscribe(res => {
          if (res[0] && res[0].result) {
            this.dataPlotTemplates = res[0].result.filter(
              item => item.type !== PLOT_TEMPLATE_TYPE.FracproXch
            );
          }

          // result from channelMappingService.getAll(this.userCompanyId)
          // unless the channelMappingData loaded from channelMappingStorageService
          if (res[1] && res[1].result) {
            this.channelMappingData = res[1].result.sort((a, b) => a > b);
            this.channelMappingStorageService.setChannelMapped(this.companyId, this.channelMappingData);
            this.realtimeChannels = this.channelSelectionService.handleChannelsColor(this.realtimeChannels, this.channelMappingData);
          }

          if (res[2] && res[2].result) {
            this.fracProChannelsLatestVer = res[2].result;
            this.fracproChannelStorageService.setFracproChannels(this.fracProChannelsLatestVer);
          }
          this.fracproChannels = this.channelSelectionService.handleChannelsColor(this.fracproChannels, this.fracProChannelsLatestVer);

          // get default template
          const curPlotTemplateId = this.realtimeTreatmentStorageService.getOption(this.padName, KEY_TEMPLATE_ID, PAD_COMPARE_WELL);
          let dataPlotTemplate;
          if (curPlotTemplateId) {
            dataPlotTemplate = this.dataPlotTemplates.find(item => item.id === curPlotTemplateId);
          } else { // in case unset local storage
            dataPlotTemplate = this.dataPlotTemplates.find(item => item.name === DEFAULT_INIT_TEMPLATE_NAME);
            if (dataPlotTemplate) {
              this.realtimeTreatmentStorageService.setOption(this.padName, KEY_TEMPLATE_ID, dataPlotTemplate.id, PAD_COMPARE_WELL);
            }
          }
          // set channel settings
          const channelSettingsStorage = this.channelSettingsStorageService.getByPad(this.padName);
          if (channelSettingsStorage) {
            this.channelSettings = channelSettingsStorage;
          }
          if (dataPlotTemplate && dataPlotTemplate.content) {
            if (this.padName !== undefined) {
              dataPlotTemplate.content.timeFormat = TIME_SETTING_TYPE.EpochTime;
            }
            if (channelSettingsStorage) {
              dataPlotTemplate.content.yAxisLeft = channelSettingsStorage.firstLeft;
              dataPlotTemplate.content.yAxisLeftMost = channelSettingsStorage.secondLeft;
              dataPlotTemplate.content.yAxisRight = channelSettingsStorage.firstRight;
              dataPlotTemplate.content.yAxisRightMost = channelSettingsStorage.secondRight;
            }
            this.loadTemplateSettings(dataPlotTemplate.content);
            this.selectedTemplate = dataPlotTemplate;
            // set channel settings
            if (!channelSettingsStorage) {
              const colorMode = this.wellList.length > 1 ? ENUM_COLOR_MODE.Flat : ENUM_COLOR_MODE.Gradient;
              this.channelSettings = this.channelSelectionService.plotTemplateToChannelSettings(dataPlotTemplate.content, this.realtimeChannels, this.fracproChannels, this.channelMappingData, false, colorMode, this.fracProChannelsLatestVer);
            }
          }
          this.loadingChannels = false;
        });
        this.subscriptions.push(subscriped);
      }

      this.loadingOverlayService.hide();
      this.getParamCompare();
    }
  }

  updateChart(isNoFetchNewData?: boolean, isFilterTreatments?: boolean) {
    if (this.compareWellsTimeControl.isAutoLoad) {
      this.updateChartManual(isNoFetchNewData, isFilterTreatments);
    }
  }

  updateChartManual(isNoFetchNewData?: boolean, isFilterTreatments?: boolean) {
    if (!isEmpty(this.wellList)) {
      if (!this.channelSelectionService.isEmptyChannels(this.channelSettings)) {
        this.reloadChartData(this.channelSettings, this.wellList, isNoFetchNewData, isFilterTreatments);
      } else {
        // clear chart data
        this.highChart.resetChart(true);
        this.highChart.setChartMessage(CHART_MESSAGES.en.pleaseSelectChannel);
      }
    }
  }

  updateDateRangeWellsTimeControl(wellList) {
    const dateRange = this.compareMultipleWellService.findDateRangeData(wellList, true);
    if (dateRange && dateRange.startTime && dateRange.endTime) {
      this.compareWellsTimeControlService.dataRangeDateTime.next(dateRange);
    }
  }

  private mapTreatmentIdOffset = well => {
    const treatmentIds: number[] = [];
    const treatmentTimeZoneOffset: number[] = [];
    for (const i of well.selectedTreatmentList) {
      treatmentIds.push(i.id);
      const timeZoneOffset = well.treatmentList.find(x => x.id === i.id);
      if (timeZoneOffset) treatmentTimeZoneOffset.push(timeZoneOffset.timezoneOffset);
      else treatmentTimeZoneOffset.push(0);
    }
    return { treatmentIds, treatmentTimeZoneOffset };
  }

  reloadChartData(channelSettings, wellList: any[], isNoFetchNewData?: boolean, isFilterTreatments?: boolean) {
    if (channelSettings && !isEmpty(wellList)) {

      // redraw chart without call api to fetch data
      if (isNoFetchNewData) {
        this.setChartInputState(channelSettings, this.filterSettings, this.chartInputData, this.pivotPointData, this.navigatorInputData);
        return;
      }

      let isFilterTreat = true;
      if (typeof isFilterTreatments !== 'undefined' && isFilterTreatments === false) {
        isFilterTreat = isFilterTreatments;
      }

      this.loadingOverlayService.show();
      const channelsMap = this.channelSelectionService.toRequestChannelMap2(channelSettings, 'name');

      // get well details timezone
      const wellSubs = wellList.map((well) => {
        return this.treatmentService.getWellDetail(well.wellId)
          .pipe(map(res => {
            const wellDetail = res.result;
            if (wellDetail.wellColor) well.wellColor = wellDetail.wellColor;
            // const dayLight = wellDetail.dayLight ? wellDetail.dayLight : 0;
            // const timezoneOffset = (wellDetail.timeZone + dayLight) / 60; // in minutes
            if (!well.tzTimeZone) well.tzTimeZone = Helper.lookupTimeZone(wellDetail.country, wellDetail.timeZone);
            well.timezoneOffset = Helper.getTimezoneOffset(new Date().toUTCString(), well.tzTimeZone);

            if (!well.treatmentList || !well.treatmentList.length) return well;

            for (const treatment of well.treatmentList) {
              // const treatmentDayLight = treatment.dayLight ? treatment.dayLight : 0;
              // const treatmentTimezoneOffset = (treatment.timeZone + treatmentDayLight) / 60; // in minutes
              treatment.timezoneOffset = Helper.getTimezoneOffset(treatment.timeStart, well.tzTimeZone);
            }
            well.timezoneOffset = well.treatmentList[0].timezoneOffset;
            return well;
          }));
      });

      forkJoin(wellSubs).pipe(flatMap(wells => {
        // update well list
        this.wellList = wells;
        this.wellTimeZoneFirstName = wells[0].tzTimeZone;
        this.wellTimeZoneFirstOffset = wells[0].timezoneOffset;

        // get main chart data
        const subMainData = wells.map((well: any) => {
          const reqOptions = { downSamplingNum: this.filterSettings.highVolumeSamplingRate };
          const { treatmentIds, treatmentTimeZoneOffset } = this.mapTreatmentIdOffset(well);
          return this.getChartDataByWell(channelsMap, well.wellId, treatmentIds, treatmentTimeZoneOffset, this.compareMultipleWellDataService, reqOptions, isFilterTreat).pipe(map(res => {
            res.forEach(wellData => {
              wellData.wellId = well.wellId;
              wellData.wellName = well.wellName;
            });

            return res;
          }));
        });

        // const subNavData = !this.filterSettings.multiWellScrollbar ? [of([])] : wells.map((well: any) => {
        //   const reqOptions = { downSamplingNum: this.filterSettings.scrollbarSamplingRate };
        //   const { treatmentIds, treatmentTimeZoneOffset } = this.mapTreatmentIdOffset(well);
        //   return this.getChartDataByWell(channelsMap, well.wellId, treatmentIds, treatmentTimeZoneOffset, this.compareMultipleWellNavigatorDataService, reqOptions, isFilterTreat).pipe(map(res => {
        //     res.forEach(wellData => {
        //       wellData.wellId = well.wellId;
        //       wellData.wellName = well.wellName;
        //     });
        //     return res;
        //   }));
        // });
        const subMappedChannel = wells.map((well: any) => {
          if (this.mappedChannelData && this.mappedChannelData.length) return of(true);
          return this.channelMappingService.getAllOriginalName(well.wellId).pipe(map(res => {
            if (!res) return [];
            return res.result.map(x => {
              const listOriginalName = x.listOriginalName;
              let listExistName: string[];
              if (!x.listExistName || !x.listExistName.length) listExistName = x.listOriginalName;
              else {
                listExistName = x.listExistName.map((value: string, index: number) => {
                  if (!value || !value.trim()) return x.listOriginalName[index];
                  else return value;
                });
              }
              const n = listExistName.length;
              const mappedChannels: IMappedChannel[] = [];
              for (let i = 0; i < n; i++) {
                mappedChannels.push({
                  id: i,
                  originalName: listOriginalName[i],
                  mappedName: listExistName[i]
                });
              }
              return { wellId: x.wellId, treatmentId: x.treatmentId, mappedChannels };
            });
          }));
        });

        return forkJoin(
          forkJoin(subMainData),
          forkJoin(subMappedChannel)
        );
      }))
        .pipe(
          finalize(() => this.loadingOverlayService.hide())
        )
        .subscribe(
          res => {
            const mainChartData: any[] = flatten(res[0]);
            if (!this.mappedChannelData || !this.mappedChannelData.length) {
              this.mappedChannelData = flatten(res[1]);
            }

            const getMinMaxTime = inputData => {
              const getParseData = (data, prop, time) => {
                if (!data || !data[prop] || !data[prop].length) return time;
                const propData = data[prop][0];
                if (!propData.values || !propData.values.length) return time;
                const firstData = propData.values[0][0];
                const lastData = propData.values[propData.values.length - 1][0];
                if (!time.startTime || firstData < time.startTime) time.startTime = firstData;
                if (!time.endTime || lastData > time.endTime) time.endTime = lastData;
                return time;
              };

              let time = { startTime: '', endTime: '' };
              for (const data of inputData) {
                time = getParseData(data, 'fracproData', time);
                time = getParseData(data, 'realtimeData', time);
              }
              return time;
            };

            const getDateTime = data => {
              const startTime = Helper.mapDateTimeUTCString(data.startTime, this.wellTimeZoneFirstName, 0);
              const endTime = Helper.mapDateTimeUTCString(data.endTime, this.wellTimeZoneFirstName, 24);
              return { startTime, endTime };
            };

            // update logic for render 'Monitor' range if there is compareWellsTimeControl
            // set startTime = 0h of startTime to endTime = 24h of endTime
            const treatmentChartData = mainChartData.filter(x => x.treatmentNumber > 0);
            if (treatmentChartData.length && treatmentChartData.length !== mainChartData.length) {
              const { startTime, endTime } = this.compareWellsTimeControl.startTime && this.compareWellsTimeControl.endTime ?
                getDateTime(this.compareWellsTimeControl) :
                getMinMaxTime(treatmentChartData);

              for (const data of mainChartData) {
                if (data.treatmentNumber > 0) continue;
                if (data.realtimeData.length && data.realtimeData[0].values) {
                  const filterRealtime = data.realtimeData[0].values.filter(x => x[0] >= startTime && x[0] <= endTime);
                  data.realtimeData[0].values = filterRealtime;
                }
                if (data.fracproData.length && data.fracproData[0].values) {
                  const filterFracpro = data.fracproData[0].values.filter(x => x[0] >= startTime && x[0] <= endTime);
                  data.fracproData[0].values = filterFracpro;
                }
              }
            }

            // mapped original channels
            if (mainChartData && mainChartData.length) {
              for (const main of mainChartData) {
                const mappedChannel = this.mappedChannelData.find(x => x.wellId === main.wellId && x.treatmentId === main.treatmentId);
                if (!mappedChannel) continue;
                main.mappedChannels = mappedChannel.mappedChannels;
              }
            }

            this.chartInputData = mainChartData;
            this.navigatorInputData = this.getNavigatorInputData(mainChartData, this.filterSettings.highVolumeSamplingRate, this.filterSettings.scrollbarSamplingRate);

            this.setChartInputState(channelSettings, this.filterSettings, this.chartInputData, this.pivotPointData, this.navigatorInputData);
          },
          (error) => {
            if (error && error.error && error.error.code === 12) {
              const wellSubs$ = this.wellList.map((well) => {
                return this.treatmentService.getListTreatments(well.wellId)
                  .pipe(map(data => {
                    const treatments = data.result;
                    const filterTreatments = (list: any[]) => {
                      if (!list || !list.length) return list;
                      return list.filter(
                        treatment => treatments && treatments.findIndex(item => item.id === treatment.id) > -1
                      );
                    }
                    well.treatmentList = filterTreatments(well.treatmentList);
                    well.selectedTreatmentList = filterTreatments(well.selectedTreatmentList);
                    well.treatment = filterTreatments(well.treatment);
                    
                    return well;
                  }));
              });
        
              forkJoin(wellSubs$).pipe(flatMap(wellList => {
                // update well list
                this.wellList = wellList;
                // set well list subject
                this.compareMultipleWellService.setWellList(this.wellList);
                // filter treatmentChannels
                if (this.treatmentChannels && this.treatmentChannels.length) {
                  let treatmentList = [];
                  const mapWellInfo = (well) => {
                    if (!well.treatmentList || !well.treatmentList.length) return null;
                    treatmentList = treatmentList.concat(well.treatmentList);
                    return well;
                  };
                  wellList.map(x => mapWellInfo(x));

                  this.treatmentChannels = this.treatmentChannels.filter(item => {
                    return treatmentList.findIndex(
                      treatment => treatment.id === item.treatmentId && treatment.wellId === item.wellId
                    ) > -1;
                  });
                }
                // reload chart
                this.setChartInputState(channelSettings, this.filterSettings, {}, this.pivotPointData, this.navigatorInputData);
                return of([]);
              }))
              .subscribe();
            }
          }
        );
    } else {
      this.setChartInputState(channelSettings, this.filterSettings, {}, this.pivotPointData, this.navigatorInputData);
    }
  }

  getNavigatorInputData(mainChartData: any[], mainSampleRate: number, navSampleRate): any[] {
    const cloneData = (inputTreatment, prop: string, step) => {
      const treatmentData = inputTreatment[prop][0];
      const values = [];
      const n = treatmentData.values.length;
      for (let i = 0; i < n; i += step) values.push(treatmentData.values[i]);
      const resData = {
        columns: treatmentData.columns,
        name: treatmentData.name,
        values
      };
      return resData;
    };

    const res: any[] = [];
    for (const treatmentData of mainChartData) {
      const navData = {
        mappedChannels: treatmentData.mappedChannels,
        treatmentId: treatmentData.treatmentId,
        treatmentNumber: treatmentData.treatmentNumber,
        wellId: treatmentData.wellId,
        wellName: treatmentData.wellName,
        fracproData: [],
        realtimeData: [],
      };

      const step = navSampleRate / mainSampleRate;
      // clone realtimeData
      if (treatmentData.realtimeData && treatmentData.realtimeData.length) {
        const realtimeData = cloneData(treatmentData, 'realtimeData', step);
        navData.realtimeData.push(realtimeData);
      }
      // clone fracproData
      if (treatmentData.fracproData && treatmentData.fracproData.length) {
        const fracproData = cloneData(treatmentData, 'fracproData', step);
        navData.fracproData.push(fracproData);
      }

      res.push(navData);
    }
    return res;
  }

  getChartDataByWell(
    channelsMap: { realtimeItems: any[], fracproItems: any[] },
    wellId, treatmentIds, wellTimeZoneOffset: number[],
    dataStoreService, reqOptions: ITreatmentChartRequestOption,
    isFilterTreatments?: boolean, isUnsetLocalData?: boolean
  ) {
    // fetch new data
    return this.compareMultipleWellService.getChartDataByGroupTreatments(
      wellId,
      treatmentIds,
      channelsMap,
      wellTimeZoneOffset,
      dataStoreService,
      isFilterTreatments,
      isUnsetLocalData,
      reqOptions
    )
      .pipe(map((res) => {
        let responseInputData = [];
        if (res) {
          responseInputData = res;
        }
        return responseInputData;
      }));
  }

  setChartInputState(channelSettings, filterSettings, inputData, pivotPointData?, navigatorInputData?) {
    // use case mapped difference channels with a same name in difference wells
    // have to find the correct cName for orignal channel in every well
    const realtimeChannels = this.getRealtimeChannelsBySettings(channelSettings);
    const mappedInputData = this.compareMultipleWellService.populateChannelSettingsByWellData(channelSettings, realtimeChannels, this.treatmentChannels, inputData);
    const mappedNavigatorInputData = this.compareMultipleWellService.populateChannelSettingsByWellData(channelSettings, realtimeChannels, this.treatmentChannels, navigatorInputData);

    this.chartInputState = {
      ...this.chartInputState,
      channelSettings: { ...channelSettings },
      filterSettings: { ...filterSettings },
      inputData: mappedInputData,
      navigatorInputData: mappedNavigatorInputData,
      pivotPointData: isArray(pivotPointData) && filterSettings.type === TIME_SETTING_TYPE.OffsetTime ? [...pivotPointData] : [],
      wellOptions: cloneDeep(this.wellList)
    };
  }

  getRealtimeChannelsBySettings(channelSettings) {
    const selectedChannels = this.channelSelectionService.getListChannels(channelSettings);
    const channelNames = selectedChannels.map(item => item.name);
    const realtimeChannels = this.channelSelectionService.toChannelsByDataField(channelNames, this.realtimeChannels, 'name');
    return realtimeChannels;
  }

  showChannelSettings() {
    const listChannelSetting = this.channelSelectionService.getListChannels(this.channelSettings);
    const channelsSelected = listChannelSetting.map(item => ({
      cName: item.cName,
      name: item.name,
      prefix: item.cName[0]
    }));
    this.dialogService.open(ChannelSelectionComponent, {
      context: {
        title: 'Channel Selection',
        compareChannel: true,
        compareWellCount: this.wellList.length,
        compareWellsInfo: this.wellList.map(item => {
          return {
            wellId: item.wellId,
            treatmentId: item.treatmentIdDefault,
            flowPathType: 0
          };
        }),
        channelsSelected,
        realtimeChannels: this.realtimeChannels,
        fracProChannels: this.fracproChannels,
        settings: cloneDeep(this.channelSettings),
        uniqueKey: 'name',
        showChannelMinMax: true,
        hideCompareBtn: true
      }
    }).onClose.subscribe(res => {
      if (res) {
        const newChannelSettings = this.channelSelectionService.formatChannelSettingModel(res);
        if (!isEqual(this.channelSettings, newChannelSettings)) {
          this.channelSettings = newChannelSettings;
          this.channelSettingsStorageService.saveByPad(this.padName, this.channelSettings, ['autoScaleYAxis']);
          if (!isEmpty(this.wellList)) {
            this.updateChart(true);
          }
        }
      }
    });
  }

  showTimeSettings() {
    this.dialogService.open(TimeSettingsComponent, {
      context: {
        compareChannel: true,
        model: this.filterSettings
      }
    }).onClose.subscribe(res => {
      if (res) {
        const newTimeSettingType = res.type;
        if (this.filterSettings.type !== newTimeSettingType) {
          this.filterSettings.type = newTimeSettingType;
          this.setChartInputState(this.channelSettings, this.filterSettings, this.chartInputData, this.pivotPointData, this.navigatorInputData);
        }
      }
    });
  }

  onCancel() {
    this.router.navigate(['pages/wells']);
  }

  zoomOut() {
    this.highChart.zoomOut();
  }

  exportChart(type: string) {
    this.clickOutsideExport();
    let data = '';
    if (this.wellList.length > 2) {
      data = moment(new Date()).format('MM-DD-YYYY');
    } else {
      data = this.wellList.map(item => item.wellName).join('_');
    }
    this.highChart.exportChart(`Compare_${data}`, type);
  }

  async loadChannelsForWells(wellList) {
    if (!isEmpty(wellList)) {
      // const loadChannel = wellList.map(x => loadEChannelForWells(x));
      let realtimeChannels = [];
      let fracproChannels = [];

      const mapWellInfo = (well, hasChannels?: boolean) => {
        if (!well.treatmentList || !well.treatmentList.length) return [];
        return well.treatmentList.map(treatment => {
          return !hasChannels 
            ? { wellId: well.wellId, treatmentId: treatment.id, treatmentNumber: treatment.treatmentNumber } 
            : { wellId: well.wellId, treatmentId: treatment.id, treatmentNumber: treatment.treatmentNumber, channels: [] };
        });
      };

      const filterWellList = wellList.map(well => well.wellId);
      return new Promise((resolve, reject) => {
        this.compareWellsService.getChannelsCompareMultiple(filterWellList).subscribe(res => {
          if (res.realtimeChannels) realtimeChannels = this.channelSelectionService.handleChannelsColor(res.realtimeChannels, this.channelMappingData);
          if (res.fracproChannels) fracproChannels = this.channelSelectionService.handleChannelsColor(res.fracproChannels, this.fracProChannelsLatestVer);

          let treatmentChannels: any[] = [];
          wellList.forEach(x => {
            treatmentChannels = treatmentChannels.concat(mapWellInfo(x, true));
          });
          // for realtimeChannels: add if treatmentId has
          for (const ch of realtimeChannels) {
            for (const tr of treatmentChannels) {
              if (ch.treatmentId === tr.treatmentId) {
                tr.channels.push(ch);
                continue;
              }
              if (ch.channelMappedGroup && ch.channelMappedGroup.length) {
                let channelExist = ch.channelMappedGroup.find(channel => channel.treatmentId == tr.treatmentId);
                if (channelExist) {
                  channelExist['channelMappedGroup'] = ch.channelMappedGroup;
                  tr.channels.push(channelExist);
                }
              }
            }
          }
          // for fracproChannels: add all to non-monitor treatment
          for (const tr of treatmentChannels) {
            if (tr.treatmentNumber === -10) continue;
            tr.channels.push(...fracproChannels);
          }

          this.treatmentChannels = treatmentChannels;
          resolve({ realtimeChannels, fracproChannels });
        }, err => {
          resolve(null);
        });
      });
    } else {
      return Promise.resolve(null);
    }
  }

  isDate(item: any) {
    if (item && item.includes('Time')) {
      return true;
    }
    return false;
  }

  toggleDisplayTooltip(event) {
    this.isDisplayTooltip = !this.isDisplayTooltip;
    this.highChart.toggleTooltip(this.isDisplayTooltip);
  }

  getParamCompare() {
    this.subscriptions.push(
      this.compareWellsService.getParamSingleCompare().subscribe(
        (res) => {
          this.parameterList = res.result;
        }
      )
    );
  }

  openButtonExportDropdown() {
    this.optionsExportOpened = !this.optionsExportOpened;
  }

  openButtonPivotDropdown() {
    this.optionsPivotOpened = !this.optionsPivotOpened;
  }

  clickOutsideExport() {
    this.optionsExportOpened = false;
  }

  clickOutsidePivot() {
    this.optionsPivotOpened = false;
  }

  onSelectPivotPoint(eventData: IResSelectPivotPoint) {
    if (eventData && eventData.selected && eventData.data) {
      this.pivotPointData = eventData.data;
      this.setChartInputState(this.channelSettings, this.filterSettings, this.chartInputData, this.pivotPointData, this.navigatorInputData);
    }
  }

  onPivotDataChange(eventData: IResSelectPivotPoint) {
    if (eventData && eventData.selected && eventData.data) {
      this.pivotPointData = eventData.data;
      this.updateChart();
    }
  }

  onWellTreatmentsChange(wellListData) {
    this.wellList = cloneDeep(wellListData);
    this.compareMultipleWellService.setWellList(this.wellList);

    const filterWellList: any[] = [];
    for (const well of this.wellList) {
      const newWell: any = { wellId: well.wellId, treatmentList: [] };
      for (const selectedTreatment of well.selectedTreatmentList) {
        const findTreatment = well.treatmentList.find(x => x.id === selectedTreatment.id);
        if (!findTreatment) continue;
        newWell.treatmentList.push(findTreatment);
      }
      if (newWell.treatmentList.length) filterWellList.push(newWell);
    }

    // find data ranges by treatment's timeStart
    const timeRange = this.compareMultipleWellService.findTimeRangeData(filterWellList, true);
    if (!isNil(timeRange) && timeRange < this.filterSettings.highResTimeRate) {
      this.filterSettings.highVolumeSamplingRate = 1;
    } else {
      this.filterSettings.highVolumeSamplingRate = this.highVolumeSamplingRate;
    }
    // update data ranges of wells
    this.updateDateRangeWellsTimeControl(this.wellList);
  }

  onSelectPlotTemplate(templateRes: IPlotTemplateResponse) {
    if (templateRes && templateRes.content) {
      this.selectedTemplate = templateRes;
      // save template id in local
      if (templateRes.id) {
        this.realtimeTreatmentStorageService.setOption(this.padName, KEY_TEMPLATE_ID, templateRes.id, PAD_COMPARE_WELL);
      }
      const template = templateRes.content;
      const isAutoScaleYAxis = false;
      const colorMode = this.wellList.length > 1 ? ENUM_COLOR_MODE.Flat : ENUM_COLOR_MODE.Gradient;
      const newSettings = this.channelSelectionService.plotTemplateToChannelSettings(template, this.realtimeChannels, this.fracproChannels, this.channelMappingData, isAutoScaleYAxis, colorMode, this.fracProChannelsLatestVer);
      if (template.timeFormat && this.wellList.length < 2) this.filterSettings.type = template.timeFormat;

      if (!isEqual(this.channelSettings, newSettings)) {
        this.channelSettings = newSettings;
        this.channelSettingsStorageService.saveByPad(this.padName, this.channelSettings, ['autoScaleYAxis']);
        // update selected channels
        // const templateChannels = this.channelSelectionService.getListChannels(newSettings);
        // to make sure not being lost data when changing channels, have to reset data in local service
        this.compareMultipleWellDataService.resetDataByTreatments();
        this.compareMultipleWellNavigatorDataService.resetDataByTreatments();
        this.updateChart();
      }
    }
  }

  onTemplatesChange(eventData) {
    this.loadingPlotTemplates = true;

    this.subscriptions.push(
      this.plotTemplateService.getByWell(this.wellId)
        .pipe(
          finalize(() => this.loadingPlotTemplates = false)
        )
        .subscribe(
          res => {
            this.dataPlotTemplates = res.result
              .filter(
                item => item.type !== PLOT_TEMPLATE_TYPE.FracproXch
              );
          }
        )
    );
  }

  loadTemplateSettings(template: IPlotTemplate) {
    if (template.timeFormat && this.wellList.length < 2) {
      this.filterSettings.type = template.timeFormat;
    } else {
      this.filterSettings.type = TIME_SETTING_TYPE.EpochTime;
    }

    this.isDisplayTooltip = !!template.isShowTooltip;
  }

  onChangeXMinMax(eventData) {
    const thisTreatmentIds = this.treatment.map(item => item.id);
    if (this.filterSettings.type === TIME_SETTING_TYPE.EpochTime) {
      if (eventData.isReset) {
        if (this.curRangeTimeMin && this.curRangeTimeMin < this.filterSettings.highResTimeRate) {
          // update zoom buffer data
          const allDataByTreatments = cloneDeep(this.compareMultipleWellDataService.getArrayDataTreatments(thisTreatmentIds));
          this.multiWellChartService.setZoomBufferData(allDataByTreatments);
        }
        // unset range time min when reset done
        this.curRangeTimeMin = undefined;
      } else {
        // no need to fetch new data if its level zooming < this.filterSettings.highResTimeRate
        if (this.curRangeTimeMin && this.curRangeTimeMin < this.filterSettings.highResTimeRate) {
          return;
        }
        const rangeTimeMinus = (eventData.maxX - eventData.minX) / (1000 * 60);
        this.curRangeTimeMin = rangeTimeMinus;
        if (rangeTimeMinus < this.filterSettings.highResTimeRate) {
          // fetch new data
          const channelsMap = this.channelSelectionService.toRequestChannelMap2(this.channelSettings, 'name');
          const reqOptions: ITreatmentChartRequestOption = {
            downSamplingNum: 10,
          };
          // reset well timezone for getting data from api
          // if (this.wellTimeZoneFirstOffset) {
          //   eventData.minX = eventData.minX - (this.wellTimeZoneFirstOffset * 60 * 1000);
          //   eventData.maxX = eventData.maxX - (this.wellTimeZoneFirstOffset * 60 * 1000);
          // }
          reqOptions.startDate = new Date(eventData.minX).toISOString();
          reqOptions.endDate = new Date(eventData.maxX).toISOString();
          reqOptions.downSamplingNum = 1;

          // get main chart data
          const subMainData = this.wellList.map((well: any) => {
            const { treatmentIds, treatmentTimeZoneOffset } = this.mapTreatmentIdOffset(well);
            return this.getChartDataByWell(channelsMap, well.wellId, treatmentIds, treatmentTimeZoneOffset, this.compareMultipleWellDataService, reqOptions, false, true)
              .pipe(map(res => {
                res.forEach(wellData => {
                  wellData.wellId = well.wellId;
                  wellData.wellName = well.wellName;
                });
                return res;
              }));
          });

          forkJoin(subMainData).subscribe(mainChartData => {
            const inputData = flatten(mainChartData);
            const realtimeChannels = this.getRealtimeChannelsBySettings(this.channelSettings);
            const mappedInputData = this.compareMultipleWellService.populateChannelSettingsByWellData(this.channelSettings, realtimeChannels, this.treatmentChannels, inputData);
            // update zoom buffer data
            this.multiWellChartService.setZoomBufferData(mappedInputData);
          });
        }
      }
    }
  }

  onChangeNavigatorMinMax(eventData) {
    if (this.filterSettings.type === TIME_SETTING_TYPE.EpochTime) {
      const thisTreatmentIds = this.treatment.map(item => item.id);
      const rangeTimeMinus = (eventData.max - eventData.min) / (1000 * 60);
      if (this.curRangeTimeMin && this.curRangeTimeMin < this.filterSettings.highResTimeRate) {
        if (rangeTimeMinus < this.filterSettings.highResTimeRate) {
          // fetch new data
          const channelsMap = this.channelSelectionService.toRequestChannelMap2(this.channelSettings, 'name');
          const reqOptions: ITreatmentChartRequestOption = { downSamplingNum: 10 };
          // reset well timezone for getting data from api
          if (this.wellTimeZoneFirstOffset) {
            eventData.min = eventData.min - (this.wellTimeZoneFirstOffset * 60 * 1000);
            eventData.max = eventData.max - (this.wellTimeZoneFirstOffset * 60 * 1000);
          }
          reqOptions.startDate = new Date(eventData.min).toISOString();
          reqOptions.endDate = new Date(eventData.max).toISOString();
          reqOptions.downSamplingNum = 1;
          // get main chart data
          const subMainData = this.wellList.map((well: any) => {
            const { treatmentIds, treatmentTimeZoneOffset } = this.mapTreatmentIdOffset(well);
            return this.getChartDataByWell(channelsMap, well.wellId, treatmentIds, treatmentTimeZoneOffset, this.compareMultipleWellDataService, reqOptions, false, true)
              .pipe(map(res => {
                res.forEach(wellData => {
                  wellData.wellId = well.wellId;
                  wellData.wellName = well.wellName;
                });
                return res;
              }));
          });

          forkJoin(subMainData).subscribe(mainChartData => {
            const inputData = flatten(mainChartData);
            const realtimeChannels = this.getRealtimeChannelsBySettings(this.channelSettings);
            const mappedInputData = this.compareMultipleWellService.populateChannelSettingsByWellData(this.channelSettings, realtimeChannels, this.treatmentChannels, inputData);
            // update zoom buffer data
            this.multiWellChartService.setZoomBufferData(mappedInputData);
          });
        } else {
          let allDataByTreatments = cloneDeep(this.compareMultipleWellDataService.getArrayDataTreatments(thisTreatmentIds));
          allDataByTreatments = allDataByTreatments.map(dataByTreatment => {
            if (dataByTreatment) {
              const dataTypes = ['realtimeData', 'fracproData'];
              dataTypes.forEach(key => {
                if (dataByTreatment[key] && dataByTreatment[key][0]) {
                  dataByTreatment[key][0].values = dataByTreatment[key][0].values.filter(dataRow => {
                    return dataRow[0] >= eventData.min && dataRow[0] <= eventData.max;
                  });
                }
              });
            }
            return dataByTreatment;
          });
          // update zoom buffer data
          this.multiWellChartService.setZoomBufferData(allDataByTreatments);
        }
      }
    }
  }

  onTimeControlStateReset(eventData: ICompareWellsTimeControl): void {
    this.compareWellsTimeControl = eventData;
    if (!this.wellList) this.wellList = [];
    else {
      this.wellList = this.wellList.map(well => {
        well.treatment = [];
        well.selectedTreatmentList = [];
        return well;
      });
    }
    // set well list subject
    this.compareMultipleWellService.setWellList(this.wellList);
    if (eventData.isAutoLoad && ((eventData.startTime && eventData.endTime) || eventData.lastDays === 'All')) {
      this.onLoadManual(eventData);
    }
  }

  onTimeControlStateChange(eventData: ICompareWellsTimeControl): void {
    this.compareWellsTimeControl = eventData;
    this.wellList = this.compareMultipleWellService.filterWellTreatmentsByDateRange(
      this.wellList,
      eventData.startTime, eventData.endTime
    );
    // set well list subject
    this.compareMultipleWellService.setWellList(this.wellList);
    if (eventData.isAutoLoad && ((eventData.startTime && eventData.endTime) || eventData.lastDays === 'All')) {
      this.onLoadManual(eventData);
    }
  }

  onLoadManual(eventData?: ICompareWellsTimeControl) {
    // clear local data
    this.compareMultipleWellDataService.resetDataByTreatments();
    this.compareMultipleWellNavigatorDataService.resetDataByTreatments();
    this.updateChartManual();
  }

  onToggleAlias(eventData: boolean) {
    this.filterSettings.showWellAliasInTag = eventData;
    // reload well list
    const curWellList = this.compareMultipleWellService.populateAliasInfo(this.wellList);
    this.wellList = cloneDeep(curWellList);
    this.compareMultipleWellService.setWellList(this.wellList);
    if (this.filterSettings.type === TIME_SETTING_TYPE.EpochTime) {
      this.highChart.toggleAliasNameAnnotation(true, true, this.filterSettings.showWellAliasInTag);
    }
  }

  addWells() {
    this.dialogService.open(WellsSelectionModalComponent, {
      context: {
        listWells: [],
        maxWells: 100,
        countItemWells: null,
        selectedListWells: cloneDeep(this.wellList)
      },
      autoFocus: false,
    })
      .onClose
      .subscribe(async selectedWells => {
        if (selectedWells) {
          this.isCompareSingleWell = selectedWells.length === 1;
          this.filterSettings.showWellAliasInTag = !this.isCompareSingleWell;

          // force reload well list
          await this.reloadDataAfterWellTreatmentsUpdate(selectedWells);
        }
      });
  }

  async reloadDataAfterWellTreatmentsUpdate(wellList, refreshTreatmentSelected: boolean = true) {
    // clear local data
    this.compareMultipleWellDataService.resetDataByTreatments();
    this.compareMultipleWellNavigatorDataService.resetDataByTreatments();
    // get wells dont have color
    const nonWellColor = wellList.filter(well => { return !well.wellColor; });
    // format well treatments name by treatment number
    wellList = this.compareMultipleWellService.handleWellTreatmentName(
      // populate alias info
      this.compareMultipleWellService.populateAliasInfo(wellList)
    );

    if (nonWellColor.length) {
      forEach(nonWellColor, (well) => {
        const dataExist = wellList.find(item => item.wellId === well.wellId);
        if (dataExist && dataExist.wellColor) {
          this.subscriptions.push(
            this.compareWellsService.updateWellColor(dataExist.wellId, dataExist.wellColor).subscribe()
          );
        }
      });
    }

    // force reload well list
    this.wellList = this.compareMultipleWellService.filterWellTreatmentsByDateRange(
      wellList,
      this.compareWellsTimeControl.startTime, this.compareWellsTimeControl.endTime,
      refreshTreatmentSelected
    );

    // update list well name
    this.wellNameList = this.wellList.map(well => well.wellName).join(', ');
    // update data ranges of wells
    this.updateDateRangeWellsTimeControl(this.wellList);
    this.childComponentListWells.reloadListWells(this.wellList);
    // set well list subject
    this.compareMultipleWellService.setWellList(this.wellList);
    // update list channels
    this.loadingChannels = true;
    const result = await this.loadChannelsForWells(this.wellList);
    if (result) {
      this.realtimeChannels = this.channelSelectionService.handleChannelsColor(result.realtimeChannels, this.channelMappingData);
      this.fracproChannels = this.channelSelectionService.handleChannelsColor(result.fracproChannels, this.fracProChannelsLatestVer);
      // handle auto reload
      if (this.compareWellsTimeControl.isAutoLoad) {
        if (((this.compareWellsTimeControl.startTime && this.compareWellsTimeControl.endTime) || this.compareWellsTimeControl.lastDays === 'All')) {
          this.onLoadManual();
        }
      }
      this.loadingChannels = false;
    }
  }

  // reload all the Treatments for already selected wells
  onRefreshDropdownWellTreatments(event) {
    const promises: any[] = [];

    forEach(this.wellList, (well) => {
      promises.push(this.compareWellsService.getListWellTreatment(well.wellId));
    });

    // get list data
    if (promises && promises.length > 0) {
      const subscriped = forkJoin(promises)
        .subscribe(
          async (response: any[]) => {
            if (response && response.length > 0) {
              const cloneWellListResponseData = response.map(data => data.result);
              const cloneWellList = cloneDeep(this.wellList);

              forEach(cloneWellListResponseData, (well, key) => {
                if (typeof cloneWellList[key] !== 'undefined') {
                  cloneWellList[key].treatmentList = well.treatmentList;
                }
              });
              // reload data
              await this.reloadDataAfterWellTreatmentsUpdate(cloneWellList, false);
            }
          }
        );

      this.subscriptions.push(subscriped);
    }
  }

  onChangeOption(eventData) {
    if (!eventData || isNil(eventData.id)) return;
    this.cursorSelected = this.cursorOpts.find(item => item.id === eventData.id);
    // handle tooltip.shared
    this.highChart.updateChartCursorOptions(this.cursorSelected);
  }


}
